<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "symptom"
};
</script>

<style lang="scss"></style>
